import React, { ReactElement, useContext } from 'react'
import Graph from '../common/Graph'
import { EntryContext } from '../contexts/EntryContext'
import { EntryRetriever } from '../reducers/EntryReducer'
import { AppContext } from '../contexts/AppContext'
import { isUsingField } from '../contexts/app/auth'
import { MIN_DURATION_FOR_LINE_GRAPH } from '../Explore/ExplorePage'

const ONE_DAY_MS = 24 * 60 * 60 * 1000
// y-axis fields alphabetical, to match the R special.graph.titles keys ("Ratings/Writing over time").
const RATING_METRICS = ['energy', 'importance', 'rating']
const WRITING_METRICS = ['complexity', 'wordcount']
const METRIC_GROUP: Record<string, string[]> = {
    rating: RATING_METRICS, energy: RATING_METRICS, importance: RATING_METRICS,
    wordcount: WRITING_METRICS, complexity: WRITING_METRICS
}

/** Over-time line graph shown above the list when browsing entries sorted by a graphable metric. */
const EntryMetricGraph = ({ field, from, until }: { field?: string, from?: string, until?: string }): ReactElement | null => {
    const { appState } = useContext(AppContext)
    const group = field ? METRIC_GROUP[field] : undefined
    if (!group) {
        return null
    }
    // A short window makes for a noisy trend line, so gate it — but only when an explicit range is given.
    if (from && until && Date.parse(until) - Date.parse(from) < MIN_DURATION_FOR_LINE_GRAPH * ONE_DAY_MS) {
        return null
    }
    // Ratings honour each field's Settings toggle; the computed writing metrics are always both shown.
    const fields = group === RATING_METRICS ? group.filter(f => isUsingField(f, appState)) : group
    if (!fields.length) {
        return null
    }
    return <EntryRetriever>
        <Graph context={ EntryContext } action={ { type: 'GRAPH_METRICS_LINE', fields: fields.join(','), from, until } } />
    </EntryRetriever>
}

export default EntryMetricGraph
